import * as React from "react";
function SearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 21a.374.374 0 01-.265-.11L16.168 16.7a7.832 7.832 0 01-5.293 2.051C6.532 18.75 3 15.217 3 10.875 3 6.532 6.532 3 10.875 3c4.342 0 7.875 3.532 7.875 7.875a7.83 7.83 0 01-2.052 5.293l4.192 4.192a.374.374 0 01-.265.64zm-9.75-17.25c-3.928 0-7.125 3.197-7.125 7.125S6.947 18 10.875 18 18 14.803 18 10.875 14.803 3.75 10.875 3.75z"
  }));
}
const ForwardRef = React.forwardRef(SearchIcon);
export default ForwardRef;